import Swiper from "swiper";
import { Pagination } from "swiper/modules";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

export function initSwiperCarousel(
  options,
  selector,
  isPagination,
  isNavigation,
  isHtmlElement
) {
  const carouselElement = isHtmlElement
    ? selector
    : document.querySelector(selector);

  options.modules = options.modules || [];

  if (isPagination) {
    options.modules.push(Pagination);
  }

  if (isNavigation) {
    options.modules.push(Navigation);
  }

  let slider = null;

  if (carouselElement instanceof HTMLElement) {
    slider = new Swiper(carouselElement, options);

    return slider;
  } else {
    console.error("Swiper container not found");
  }
}
